import React, {FC} from 'react';
import renderInlineSvg from '~/utils/renderInlineSvg';
import {lightbulb} from '~/constants/InlineSvgs';
import {Box, Typography} from '@customink/pigment-react';
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';

interface HelpfulTipProps {
  className?: string;
  sx?: React.CSSProperties;
  children: React.ReactNode;
}
const HelpfulTip: FC<HelpfulTipProps> = ({className, sx, children}) => (
  <Box
    className={className}
    display="flex"
    sx={{
      alignItems: 'center',
      backgroundColor: designTokens.color.gray.light.value,
      flexFlow: 'row',
      margin: '1rem',
      padding: '1rem',
      borderRadius: '4px',
      gap: '.5rem',
      ...sx
    }}>
    <Box
      sx={{
        display: 'flex',
        flex: '0 0 auto',
        svg: {
          height: '1.25rem',
          width: '1.25rem'
        }
      }}
      dangerouslySetInnerHTML={renderInlineSvg(lightbulb)}
    />
    <Typography
      sx={{
        flex: '1 1 auto'
      }}
      component="div"
      variant="uiTextDefault">
      {children}
    </Typography>
  </Box>
);

export default HelpfulTip;
